import React from 'react'
import './drop-down-item.css'
export default function DropDownItem({ itemName, number}) {
    return (
        <div className="drop-item">
            <div className="drop-text">
                <p className="drop-header">{itemName}</p>
                <p className="drop-detail">{number}</p>
            </div>
        </div>
    )
}
